import React from "react";
import { DeliveryLogsContainer } from "../styled";

const DeliveryLogs = ({ logs }) => {
  return (
    <DeliveryLogsContainer>
      <ul className="logs">
        {logs.map((log, i) => (
          <li key={i}>
            <span className="dot"></span>
            <p>
              {log.location} · {log.status}
            </p>
            <span>{log.time}</span>
          </li>
        ))}
      </ul>
      <p>· 배송 추적 서비스를 통해 제공받는 정보로 실 배송 현황과 차이가 있을 수 있습니다.</p>
    </DeliveryLogsContainer>
  );
};

export default DeliveryLogs;
